import i18n from './../../shared/i18n';
import BaseModel from "../../core/components/input-widget/BaseModel";
import {Formatter} from "@/core/services/formatter.service";
import ReservationModel from "@/modules/inventory/Reservation.model";
import {store} from "@/plugins/vuex";
import {getPhoneRuleObj} from "@/plugins/vee-validate";
import SourceInventoryModel from "@/modules/inventory/group-items/SourceInventory.model";

export default class InventoryModel extends BaseModel {
  uuid = null;
  receipt_uuid = null;
  rep_user_uuid = null;
  expert_user_uuid = null;
  lot_handling_charge = null;
  rebate_rate = null;
  item_no = null;
  receive_date = Formatter.getNowAsDate();
  dynamic_fields = {};
  department_uuid = null;
  category_uuid = null;
  category = {};
  specialists_uuids = [];
  specialists = [];
  cataloguing_lifecycle = null;
  photography_lifecycle = null;
  lifecycle_last_updated = {};
  item_location_uuid = null;
  pre_release_item_location_uuid = null;
  low = null;
  high = null;
  start_price = null;
  reserve_per_unit = null;
  reserve = null;
  buy_now_price = null;
  tax_status_uuid = null;
  tax_rate = null;
  net_reserve = false;
  insurance = null;
  collected = false;
  quantity = 1;
  available_quantity = 1;
  department = {};
  rep_user = {};
  reservations = [];
  financial_items = [];

  collection_info_enabled = false;
  collection_info_address_1 = null;
  collection_info_address_2 = null;
  collection_info_state = null;
  collection_info_municipality = null;
  collection_info_city = null;
  collection_info_zip_code = null;
  collection_info_phone = null;
  collection_info_first_name = null;
  collection_info_last_name = null;
  collection_info_email = null;
  collection_info_notes = null;
  collection_info_full = null;
  longitude = null;
  latitude = null;
  account_managers_uuid = null;
  account_managers = {}
  is_grouped_item = false
  published_at_least_once = false
  source_inventories = []
  reserve_type = null

  customMessages = {
    "start_price": {
      max_value: function () {
        return i18n.t("The 'Start Price' must be lower than the 'Reserve' price.")
      }
    }
  }

  rules = {
    item_no: 'max:10',
    quantity: 'required|min_value:1',
    item_location_uuid: 'required',
    insurance: 'max_value:100|min_value:0',
    minimum_commission: 'max_value:100|min_value:0',
    rebate_rate: 'max_value:100|min_value:0',
    department_uuid: 'required',
    category_uuid: 'required',
    low: 'min_value:1',
    high: 'min_value:1',
    start_price: 'min_value:0',
    reserve: 'min_value:1',
    buy_now_price: 'min_value:1',
    tax_rate: 'max_value:100|min_value:0',

    collection_info_email: 'email|max:73',
    collection_info_notes: 'max:150',
    collection_info_phone: getPhoneRuleObj(),
    longitude: 'min_value:-180|max_value:180',
    latitude: 'min_value:-85|max_value:85',
  };

  attributeHints = {
    item_no: i18n.t('Will be automatically generated if left blank'),
    tax_status_uuid: i18n.t('Vendor tax status will be assigned if left blank'),
    tax_rate: i18n.t('Vendor tax rate will be assigned if left blank'),
    title: i18n.t('For formatting, please highlight the text'),
    description: i18n.t('For formatting, please highlight the text'),
  };

  attributeLabels = {
    uuid: i18n.t('UUID'),
    quantity: i18n.t('Quantity'),
    available_quantity: i18n.t('Available Quantity'),
    receipt_uuid: i18n.t('Receipt'),
    rep_user_uuid: i18n.t('Representative User'),
    expert_user_uuid: i18n.t('Expert User'),
    lot_handling_charge: i18n.t('Lot Handling Charge'),
    item_no: i18n.t('Item Number'),
    sale_no: i18n.t('Sale Number'),
    receive_date: i18n.t('Receive Date'),
    description: i18n.t('Description'),
    department_uuid: i18n.t('Department'),
    category_uuid: i18n.t('Category'),
    specialists_uuids: i18n.t('Specialists'),
    low: i18n.t('Low'),
    high: i18n.t('High'),
    start_price: i18n.t('Start Price'),
    reserve: i18n.t('Reserve'),
    buy_now_price: i18n.t('Buy Now'),
    net_reserve: i18n.t('NET Reserve'),
    item_location_uuid: i18n.t('Item Location'),
    year: i18n.t('Year'),
    title: i18n.t('Title'),
    creator: i18n.t('Creator'),
    collected: i18n.t('Collected'),
    tax_status_uuid: i18n.t('Tax Status'),
    tax_rate: i18n.t('Tax Rate'),

    minimum_commission: i18n.t('Minimum Commission'),
    branch: i18n.t('Branch'),
    auction: i18n.t('Sale'),
    receipt: i18n.t('Receipt'),
    category: i18n.t('Category'),
    currency: i18n.t('Currency'),
    customer: i18n.t('Customer'),
    rep_user: i18n.t('Representative User'),
    insurance: i18n.t('Insurance'),
    expert_user: i18n.t('Expert User'),
    item_location: i18n.t('Item Location'),
    insurance_rate: i18n.t('L/D Warranty'),
    rebate_rate: i18n.t('Rebate'),
    withdrawal_fee: i18n.t('Withdrawal Fee'),
    department: i18n.t('Department'),
    unsold_fee: i18n.t('Unsold Fee'),
    tax_status: i18n.t('Tax Status'),

    collection_info_enabled: i18n.t('Collection Information'),
    collection_info_address_1: i18n.t('Address 1'),
    collection_info_address_2: i18n.t('Address 2'),
    collection_info_city: i18n.t('City'),
    collection_info_state: i18n.t('State/County'),
    collection_info_municipality: i18n.t('Municipality'),
    collection_info_zip_code: i18n.t('Zip/Postcode'),
    collection_info_phone: i18n.t('Phone'),
    collection_info_first_name: i18n.t('Contact First Name'),
    collection_info_last_name: i18n.t('Contact Last Name'),
    collection_info_email: i18n.t('Email'),
    collection_info_notes: i18n.t('Collection Notes'),
    collection_info_full: i18n.t('Collection Information'),
    longitude: i18n.t('Longitude'),
    latitude: i18n.t('Latitude'),
    account_managers_uuid: i18n.t('Account Manager'),
    reserve_per_unit: i18n.t('Reserve per Unit'),
    reserve_type: i18n.t('Reserve Type'),
    stock_no: i18n.t('Stock No'),
    account_managers: i18n.t('Account Managers'),
    cataloguing_lifecycle: i18n.t('Cataloguing Lifecycle'),
    photography_lifecycle: i18n.t('Photography Lifecycle'),
  };

  toJSON() {
    let data = super.toJSON();

    data.account_managers_uuid = data.account_managers_uuid ? [data.account_managers_uuid] : [];

    delete data.account_managers;

    return data;
  }

  // check if dynamic fields from selected category exist and have value on receipt level and inherit if they do
  inheritDynamicFieldsValues() {
    if (store && store.state && store.state.global && !this.uuid && this.receipt) {
      if (store.state.global.isDynamicFieldsTemplateFromCategory && store.state.global.inheritDynamicFieldsValues) {
        if (this.category && this.category.dynamic_fields_template) {
          let category_dfs = Object.keys(this.category.dynamic_fields_template);
          const locale = store.state.global.locales.master_language.key;
          let receipt_dfs = this.receipt.dynamic_fields[locale];
          if (receipt_dfs) {
            for (let key of category_dfs) {
              if (receipt_dfs[key]) {
                this[`${key}_${locale}`] = receipt_dfs[key];
                this[key][locale] = this[`${key}_${locale}`]
              }
            }
          }
        }
      }
    }
  }

  constructor(data = {}, runInit = true) {
    super();
    Object.assign(this, {...data});

    if (this.reservations && this.reservations.length > 0) {
      const reservations = [];
      for (let reservationData of this.reservations) {
        reservations.push(new ReservationModel(reservationData))
      }
      // This is when all reservations from api are withdrawn and we need to add at least one reservation
      if (reservations.length === 0) {
        reservations.push(new ReservationModel())
      }
      this.reservations = reservations;
    }

    if (this.account_managers && this.account_managers.length > 0) {
      this.account_managers_uuid = this.account_managers[0].uuid
    } else {
      this.account_managers_uuid = null;
    }

    let sourceInventories = [];
    if (this.is_grouped_item && this.source_inventories) {
      this.source_inventories.forEach(si => sourceInventories.push(new SourceInventoryModel(si)))
    }
    this.source_inventories = sourceInventories;

    if (runInit) {
      this.initDynamicFields(this, this.category ? this.category.dynamic_fields_template : null);
    }
  }

  initDynamicFields(object, dynamicFieldsTemplate = null) {
    let superInitResult;
    if (this.is_grouped_item && store.state && store.state.global && store.state.global.defaultItemDynamicFieldsTemplate) {
      superInitResult = super.initDynamicFields(object, store.state.global.defaultItemDynamicFieldsTemplate);
    } else {
      superInitResult = super.initDynamicFields(object, dynamicFieldsTemplate);
    }
    this.inheritDynamicFieldsValues();
    return superInitResult;
  }
}
